// Settings of this PC lived here until 2026-11-04 (decision 141): the one
// Settings page holds them now; an old link lands there.

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/pc/settings")({
  beforeLoad: () => {
    throw redirect({ to: "/settings", hash: "pc", replace: true });
  },
});
